import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
	storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    auth: null
  },
  mutations: {
    SET_AUTH: function(state, value) {
			state.auth = value;
		}
  },
  actions: {
    // To save user auth
		set_auth: (context, value) => {
			context.commit('SET_AUTH', value);
		}
  },
  modules: {
  },
	plugins: [vuexLocal.plugin]
})
